import HeaderBottom from "./header-bottom";
import HeaderTop from "./header-top";
import MainMenu from "./main-menu";

export default function Header() {
  return (
    <header className="ec-header">
      {/* <HeaderTop /> */}
      <HeaderBottom />
      <MainMenu />
    </header>
  );
}
